/* eslint-disable prefer-promise-reject-errors */

function processData(data) {
  try {
    return JSON.parse(data);
  } catch (err) {
    return data;
  }
}

function toJSON(resp) {
  if (resp.text) {
    return resp.text().then(processData);
  }
  if (resp instanceof Promise) {
    return resp.then(processData);
  }
  return Promise.resolve(resp).then(processData);
}

export default function(fetch) {
  return (url, opts) =>
    fetch(url, opts)
      .then(resp => {
        // Normalize IE9's response to HTTP 204 when Win error 1223.
        const status = resp.status === 1223 ? 204 : resp.status;
        const statusText =
          resp.status === 1223 ? 'No Content' : resp.statusText;

        if (status >= 400) {
          return toJSON(resp).then(data =>
            Promise.reject({ status, statusText, message: data.message })
          );
        }
        return toJSON(resp).then(data => {
          if (status >= 200 && status < 300) {
            return data;
          }
          return Promise.reject(data);
        });
      })
      .catch(error => Promise.reject(error));
}



// WEBPACK FOOTER //
// ./src/api/fetchAdapter.js